import { Wallet } from '@injectivelabs/wallet-base';
export const cosmosWallets = [
    Wallet.Leap,
    Wallet.Ninji,
    Wallet.Keplr,
    Wallet.OWallet,
];
//# sourceMappingURL=index.js.map